import _ from 'lodash'
import Backbone from 'backbone'
import template from 'scoreboard/datasets/overview/set-repeat-by-grouping.hbs'
import OnOffToggle from 'scoreboard/components/on-off-toggle'
import FormView from 'scoreboard/components/form-view'
import formHelper from 'scoreboard/components/form-helper'
import calendars from 'scoreboard/components/calendars'
import config from 'scoreboard/components/config'
import BackboneSelect from 'scoreboard/components/backbone-select'
import i18n from 'scoreboard/components/i18n'
import highlight from 'scoreboard/components/highlight'
import isNumericDataType from 'scoreboard/components/is-numeric-data-type'
import renderFieldDropdown from '../render-field-dropdown'
import unwrapModel from 'scoreboard/components/unwrap-model'
import { getRepeatByGroupingType } from 'scoreboard/datasets/overview/get-repeat-by-grouping'
import GroupedPeriodRangeSelector from 'scoreboard/components/designer/grouped-period-range-selector'
import isGeographicOrRollup from '../is-geographic-or-rollup'
import SummaryType from 'scoreboard/datasets/model/summary-type'
const { SIMILAR_TIME_RANGES, DAY_OF_THE_WEEK, MONTH_OF_THE_YEAR } = SummaryType
import DataType from 'scoreboard/datasets/model/data-type'
const { TEXT, DATE } = DataType

/**
 * SummaryType values that map in the UI to "Similar Time Ranges"
 */
const SIMILAR_TIME_RANGES_SUMMARY_TYPES =
	[SIMILAR_TIME_RANGES, DAY_OF_THE_WEEK, MONTH_OF_THE_YEAR]


// the maximum number of values allowed in a text or numeric field for it to do
// a repeat by grouping instead of range
var MAX_VALUES = 500

var SetRepeatByGrouping = Backbone.View.extend({

	tagName: 'form',

	className: 'set-repeat-by-grouping',

	events: {
		'change [name=fieldIdentifier]': 'changeField',
		'change [name=summaryType]': 'changeSummaryType',
		'change [name=values]': 'renderSimilarTimeRanges'
	},

	/** @type {Dataset} */
	model: null,

	/**
	 * For setting row and column repeat by groupings (#12826).  The first step in the
	 * wizard.
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Dataset} options.model the dataset displayed on the Dataset Overview
	 *
	 * @param {Object} options.table the table whose repeat by grouping is to be customized
	 *
	 * @param {String} options.repeatByType either 'row' or 'column'
	 *
	 * @param {Object} options.grouping the repeat by grouping
	 *
	 * @param {Object} options.otherGrouping the data for the "other"
	 * repeat by grouping for the table.  For example if repeatByType is 'row', will
	 * have the data for the column repeat by grouping
	 *
	 * @param {Object} options.suggestions suggestions for any text fields.
	 * Keys are field IDs, and values for the map are the List of suggestions.
	 *
	 * @param {Object} options.wizard the RepeatByGroupingWizard this dialog participates in
	 */
	initialize: function(options) {
		this.options = options || {}
		var SetRepeatByFormView = FormView.extend({
			test: this.test.bind(this)
		})
		this.formView = new SetRepeatByFormView({
			el: this.el,
			submit: this.submit.bind(this),
			guard: false,
			allowCleanSubmission: options.wizard.lastNavigable > 1
		})
		this.grouping = options.grouping || {}
	},

	render: function() {
		this.$el.empty().append(template(this.context()))

		this.renderShowToggle()
		this.renderGroupBySelect()
		this.toggleRepeatByGroupingControls()

		this.options.wizard.render({
			formView: this.formView,
			stateSaver: this.saveState.bind(this)
		})

		this.renderSimilarTimeRanges()

		this.formView.start()
		return this
	},

	renderShowToggle() {
		var breakdownFieldId = this.grouping.fieldId
		// whether we are showing breakdown columns/rows
		var show = !_.isNil(breakdownFieldId)
		this.showToggle = new OnOffToggle({
			name: 'show',
			checked: show,
			label: i18n.get('datasets.breakdown.' + this.options.repeatByType + 's.show')
		})
		this.showToggle.on('change', checked => {
			this.toggleRepeatByGroupingControls()
			this.formView.change()
			if (!checked) {
				_.invoke(this.markedField, 'clearError')
			}
		})
		this.$('.show-toggle-container').append(this.showToggle.el)
		this.showToggle.render()
	},

	renderGroupBySelect: function() {
		let underlyingTableFieldId =
			this.model.getUnderlyingField(this.options.table.get('fieldId')).id
		let fields = _.filter(this.model.combinedFields, field => {
			let underlyingField = this.model.getUnderlyingField(field)
			// #26539 don't allow breakdown on same underlying field as
			// the table's field
			if (underlyingField.id == underlyingTableFieldId) {
				return false
			}
			if (field.aggregationType === 'none') {
				return false
			}

			var otherBreakdownId = _.get(this.options.otherGrouping, 'fieldId')
			if (field.id == otherBreakdownId) {
				return false
			}
			return true
		})
		let vlfs = this.model.get('visibleLinkedFields')
		let otherBreakdownVlf = _.get(this.options.otherGrouping,
			'visibleLinkedFieldId')
		let allowedVisibleLinkedFields = _.filter(vlfs, vlf => {
			let underlyingField = this.model.getUnderlyingField(vlf.fieldId)
			return vlf.id != this.options.table.get('visibleLinkedFieldId') &&
				vlf.id != otherBreakdownVlf &&
				// #26539 don't allow breakdown on same underlying field as
				// the table's field
				underlyingTableFieldId != _.get(underlyingField, 'id')
		})
		let selectedId = this.model.idsToFieldIdentifier({
			fieldId: this.grouping.fieldId,
			visibleLinkedFieldId: this.grouping.visibleLinkedFieldId
		})
		this.markedField = renderFieldDropdown({
			el: this.$('[name=fieldIdentifier]'),
			allowedFieldIds: _.map(fields, 'id'),
			allowedVisibleLinkedFieldIds: _.map(allowedVisibleLinkedFields, 'id'),
			dataset: this.model,
			selectedId,
			required: true
		})
	},

	renderSimilarTimeRanges: function() {
		this.groupedPeriodRangeSelector && this.groupedPeriodRangeSelector.remove()

		const container = this.$('.group-similar-time-ranges-container')
		const value = this.$('[name=values]').val()
		if (!SIMILAR_TIME_RANGES_SUMMARY_TYPES.includes(value)) {
			container.addClass('is-not-displayed')
			return
		}

		container.removeClass('is-not-displayed')

		this.groupedPeriodRangeSelector = new GroupedPeriodRangeSelector({
			model: GroupedPeriodRangeSelector.createModel(this.grouping),
			usePeriodRanges: false
		})

		this.$('.group-similar-time-ranges-container')
			.append(this.groupedPeriodRangeSelector.$el)

		this.groupedPeriodRangeSelector.render()
	},

	context: function() {
		var titleKey = 'datasets.breakdown.' + this.options.repeatByType + 's'
		return {
			titleKey: titleKey
		}
	},

	toggleRepeatByGroupingControls: function() {
		var show = this.showToggle.val()
		this.$el.toggleClass('is-hiding-controls', !show)
		if (show) {
			this.changeField()
		}
	},

	changeField: function() {
		var field = unwrapModel(this.getField())
		if (!field) {
			return
		}

		var options
		var summaryType = this.grouping.summaryType

		// most field types shouldn't have these
		this.$('.breakdown-by, .breakdown-values, .group-similar-time-ranges-container')
			.addClass('is-not-displayed')

		// whether automatic rollups are allowed
		var automatic = isGeographicOrRollup(field.dataType)
		this.$('.automatic').toggleClass('is-not-displayed', !automatic)
		if (!isGeographicOrRollup(field.dataType)) {
			this.options.wizard.oneStep()
			this.options.wizard.render({
				formView: this.formView
			})
		}

		if (field.dataType === TEXT || isNumericDataType(field.dataType)) {
			summaryType = summaryType === 'value' ? 'value' : 'range'
			summaryType = summaryType ||
				_.isEmpty(field.ranges ? 'value' : 'range')
			var rangeKey = 'datasets.breakdown.range.' +
				(field.dataType === TEXT ? TEXT : 'numeric')
			options = [ {
				value: 'value',
				label: field.label
			}, {
				value: 'range',
				label: i18n.get(rangeKey, field.label)
			} ]
			// this always goes in the DOM so formHelper can read from it, even
			// if it's not displayed
			this.renderSummaryTypeToggle(summaryType, options)

			if (!_.isEmpty(field.ranges)) {
				this.$('.breakdown-by').removeClass('is-not-displayed')
			}
		}

		if (field.dataType === DATE) {
			this.$('.breakdown-values').removeClass('is-not-displayed')

			if (!this.valuesSelect) {
				const options = _.clone(calendars.calendars)
				// #50425 need at least 2 calendars to group similar time ranges
				if (calendars.calendars.length > 1) {
					options.push({
						id: 'similar-time-ranges',
						label: i18n.get('datasets.choose.groupSimilarTimeRanges')
					})
				}
				this.valuesSelect = new BackboneSelect({
					el: this.$('[name=values]'),
					options: options,
					required: true,
					accessors: {
						value: 'id'
					}
				}).render()
				let value = summaryType
				if (SIMILAR_TIME_RANGES_SUMMARY_TYPES.includes(value)) {
					value = SIMILAR_TIME_RANGES
				} else {
					value = this.grouping.groupCalendarId ||
						config.ytdCalendarId
				}
				this.valuesSelect.val(value)
			}

			// update display of groupedPeriodRangeSelector if changing from
			// one date fields to another
			this.renderSimilarTimeRanges()
		}
	},

	changeSummaryType: function(e) {
		this.formView.change(e)
	},

	renderSummaryTypeToggle: function(summaryType, options) {
		_.result(this.summaryTypeToggle, 'remove')
		_.forEach(options, option => {
			let label = this.$(`.breakdown-${option.value}`)
			label.find('[name=summaryType]')
				.attr('checked', summaryType === option.value)
			label.find('.text-label').text(option.label)
		})
	},

	getField: function() {
		let fieldEl = this.$('[name=fieldIdentifier]')
		var fieldIdentifier = fieldEl.val()
		if (!fieldIdentifier) {
			return null
		}
		if (!fieldEl.is(':visible')) {
			return null
		}
		return this.model.getFieldByFieldIdentifier(fieldIdentifier)
	},

	test: function() {
		var msg = FormView.prototype.test.apply(this, arguments)
		if (msg) {
			return msg
		}

		var highlighted

		// don't allow repeat by groupings by value if there were greater than
		// MAX_VALUES values for text or number fields
		var field = this.getField()
		// the field will be null if repeat by grouping columns aren't specified
		if (!field) {
			return
		}

		if (isNumericDataType(field.dataType) ||
			field.dataType === TEXT) {
			if (this.getState().summaryType === 'value' ||
				_.isNil(this.getState().summaryType)) {
				var suggestions = this.options.suggestions[this.getField().id]
				if (_.isNil(suggestions) || suggestions.length > MAX_VALUES) {
					highlighted = highlight(field.label)
					return i18n.get('datasets.breakdown.maxValues.error', highlighted)
				}
			}
		}

		// don't allow breakdowns by value if there were greater than
		// MAX_VALUES values for calendar fields
		let value = _.result(this.valuesSelect, 'val')
		if (field.dataType === DATE && !_.isEmpty(value) &&
			value != 'similar-time-ranges') {
			var calendar = calendars.calendarsById[value]
			if (_.size(calendar.periods) > MAX_VALUES) {
				highlighted = highlight(calendar.label)
				return i18n.get('datasets.breakdown.maxValues.error.date', highlighted)
			}
		}
	},

	submit: function() {
		const grouping = this.getState()
		if (this.options.wizard.steps == 1) {
			this.options.wizard.finish(grouping)
			this.trigger('done', grouping)
		} else {
			this.options.wizard.next()
		}
	},

	getState: function() {
		let grouping = formHelper.readFromDom(this.el)
		let ids = this.model.fieldIdentifierToIds(grouping.fieldIdentifier)
		_.extend(grouping, ids)
		delete grouping.fieldIdentifier
		grouping = _.pickBy(grouping, datum => datum != null)

		let field = this.getField()
		if (!field) return

		// for calendar breakdowns, wrap the calendar ID in an array to make the
		// server happy
		if (field.dataType === DATE) {
			let value = grouping.values
			if (value === 'similar-time-ranges') {
				_.extend(grouping,
					this.groupedPeriodRangeSelector.idsAndSummaryType())
				delete grouping.values
			} else {
				grouping.summaryType = 'calendar'
				grouping.groupCalendarId = value
			}
		}

		// if this is a rollup breakdown
		if (isGeographicOrRollup(field.dataType)) {
			grouping.summaryType = 'automatic'
			if (grouping.summaryType === 'values') {
				grouping.values = this.options.grouping.values
			}
		}

		// always set the grouping type
		grouping.type = _.get(this.options.grouping, 'type') ||
			getRepeatByGroupingType(this.options.repeatByType)

		return grouping
	},

	saveState: function() {
		this.options.wizard.saveState(this.getState())
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.markedField,
			this.showToggle, this.valuesSelect,
			this.groupedPeriodRangeSelector], 'remove')
	}

})

export default SetRepeatByGrouping

SetRepeatByGrouping.__filename__ = 'datasets/overview/set-repeat-by-grouping.js'
